/**
 * Secure Remember Me utility
 * Stores credentials with encryption and automatic expiry
 */

const STORAGE_KEY = 'hj_remember_me';
const EXPIRY_DAYS = 30; // Credentials expire after 30 days

// Simple obfuscation (not true encryption, but prevents casual reading)
// For production, consider using Web Crypto API or a proper encryption library
const encode = (str) => {
  try {
    return btoa(encodeURIComponent(str).split('').reverse().join(''));
  } catch {
    return null;
  }
};

const decode = (str) => {
  try {
    return decodeURIComponent(atob(str).split('').reverse().join(''));
  } catch {
    return null;
  }
};

/**
 * Save credentials securely with expiry
 * @param {string} identifier - User email or E.164 phone number
 * @param {string} password - User password
 */
export const saveCredentials = (identifier, password) => {
  try {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + EXPIRY_DAYS);

    const data = {
      i: encode(identifier),
      p: encode(password),
      x: expiryDate.getTime() // expiry timestamp
    };

    localStorage.setItem(STORAGE_KEY, encode(JSON.stringify(data)));
    return true;
  } catch (error) {
    console.error('Failed to save credentials:', error);
    return false;
  }
};

/**
 * Load saved credentials if valid and not expired
 * @returns {{ identifier: string, password: string } | null}
 */
export const loadCredentials = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;

    const decoded = decode(stored);
    if (!decoded) {
      clearCredentials();
      return null;
    }

    const data = JSON.parse(decoded);

    // Check expiry
    if (data.x && Date.now() > data.x) {
      clearCredentials();
      return null;
    }

    // Support both old format (e=email) and new format (i=identifier)
    const identifier = decode(data.i) || decode(data.e);
    const password = decode(data.p);

    if (!identifier || !password) {
      clearCredentials();
      return null;
    }

    return { identifier, password };
  } catch (error) {
    console.error('Failed to load credentials:', error);
    clearCredentials();
    return null;
  }
};

/**
 * Clear saved credentials
 */
export const clearCredentials = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear credentials:', error);
  }
};

/**
 * Check if credentials are saved
 * @returns {boolean}
 */
export const hasStoredCredentials = () => {
  return loadCredentials() !== null;
};
